import { useNavigate } from "react-router-dom";

import {
    FaMapMarkerAlt,
   
    FaTimesCircle,
    FaEye,
} from "react-icons/fa";
import getImageUrl from "../../../../utils/imageUrl";
import StatusBadge from "./StatusBadge";

import "./OrderCard.css";

function OrderCard({

    order,

    onCancel,

}) {

    const navigate = useNavigate();

    const firstItem = order.items?.[0];

    const status = order.status;

    const canCancel = [

        "Pending",

        "Accepted",

    ].includes(status);

    const delivered =

        status === "Delivered";

    const cancelled =

        status === "Cancelled" ||

        status === "Rejected";

    return (

       <div
    className={`order-card ${
        delivered
            ? "delivered"
            : cancelled
            ? "cancelled"
            : "pending"
    }`}
>

            {/* Food Image */}

            <div className="order-image">

<img
    src={
        getImageUrl(firstItem?.image) ||
        "/images/food-placeholder.png"
    }
    alt={firstItem?.foodName || "Food"}
    className="order-food-image"
    onError={(e) => {
        e.currentTarget.src =
            "/images/food-placeholder.png";
    }}
/>

            </div>

            {/* Details */}

            <div className="order-content">

              <div className="order-top">

    <div className="order-details">

        <div className="order-title-row">

            <h3>{firstItem?.foodName}</h3>

            <StatusBadge status={status} />

        </div>

        <p>{order.providerSnapshot?.businessName}</p>

    </div>

</div>

                <div className="order-info">

                    <span>

                        Qty :

                        {

                            firstItem?.quantity

                        }

                    </span>

                    <span>

                        ₹

                        {

                            order.grandTotal

                        }

                    </span>

                </div>

                <div className="order-number">

                    Order #

                    {

                        order.orderNumber

                    }

                </div>

                <div className="order-date">

                    {

                        new Date(

                            order.createdAt

                        ).toLocaleString()

                    }

                </div>

                {/* Buttons */}

               {/* Buttons */}

{!delivered && (

    <div className="order-actions">

        {canCancel && (

            <button
                className="cancel-btn"
                onClick={() => onCancel(order._id)}
            >
                <FaTimesCircle />
                Cancel
            </button>

        )}

        {!cancelled && (

            <button
                className="track-btn"
                onClick={() =>
                    navigate(`/customer/orders/${order._id}`)
                }
            >
                <FaMapMarkerAlt />
                Track Order
            </button>

        )}

        {cancelled && (

            <button className="view-btn">

                <FaEye />

                View Details

            </button>

        )}

    </div>

)}

            </div>

        </div>

    );

}

export default OrderCard;